import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=9dab2648&scoped=true&"
var script = {}
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=9dab2648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dab2648",
  null
  
)

export default component.exports